

export function serializeQuery(query) {
    return {
        ...query,
        page: query.page ?? 1,
    }
}

export function parseQuery(query) {
    return {
        ...query,
        category: query.category ?? null,
        job_contract_type: query.job_contract_type ?? null,
    }
}